/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import {
  Page, Control, Divider,
} from '@vlabs/uikit';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from './PlansForm.module.sass';

function PlansForm({
  onSubmit,
  defaultValues,
}) {
  const { t } = useTranslation();
  const {
    handleSubmit, register, formState: { errors },
  } = useForm({ defaultValues });

  const title = defaultValues ? t('plans:update_plan') : t('plans:create_plan');

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Page className={st.Root} title={title}>
        <Divider />

        <label htmlFor="role">
          {t('plans:plan_name')}
          <Control.Input
            {...register('name', {
              required: t('validation.required'),
            })}
            errors={errors}
          />
        </label>

        <Divider small />
        <label htmlFor="role">
          {t('plans:plan')}
          <Control.FileInput
            {...register('image', {
            })}
            errors={errors}
          />
        </label>

        <Divider small />

        <Control.Button fullWidth type="submit">
          {t('form.submit')}
        </Control.Button>
      </Page>
    </form>
  );
}

export default PlansForm;
